<div mat-dialog-content>
  <img src="../../../../assets/images/gemini/img.png" alt="" />
</div>
